import { BingAttribute, BingAttributeMetaData, ValueType } from '@vendasta/listing-products';

export interface BingAttributeFull {
  name: string;
  displayName: string;

  valueDisplayNames: string[];
  value: unknown;
  valueType: ValueType;
}

// The BingAttribute is optional and will only exist if this attribute is set to a value.
export function CreateAttribute(a: BingAttribute, md: BingAttributeMetaData): BingAttributeFull {
  const attribute: BingAttributeFull = {
    name: md.parent,
    displayName: md.displayName,
    valueType: md.valueType,
    valueDisplayNames: md.valueDisplayNames,
    value: null,
  };
  if (!!a && a.value != null) {
    attribute.value = a.value;
  }
  return attribute;
}

export function GetBingAttributeFromAttribute(a: BingAttributeFull): BingAttribute {
  if (!a || a.value === null) {
    return undefined;
  }

  const ga: BingAttribute = {
    name: a.name,
    value: null,
    toApiJson: () => ({} as object),
  };

  // convert value back to value type
  switch (a.valueType) {
    case ValueType.BOOL:
      ga.value = a.value === 'true';
      break;
    default:
      break;
  }

  return ga;
}
